"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationSectionAnswer {
  static thaw(evaluationSectionAnswerObj) {
    if (evaluationSectionAnswerObj == null) return null;
    const evaluationSectionAnswer = new EvaluationSectionAnswer();
    if (evaluationSectionAnswerObj.id != null) evaluationSectionAnswer.setId(evaluationSectionAnswerObj.id);
    if (evaluationSectionAnswerObj.notes != null) evaluationSectionAnswer.setNotes(evaluationSectionAnswerObj.notes);
    if (evaluationSectionAnswerObj.evaluationId != null) evaluationSectionAnswer.setEvaluationId(evaluationSectionAnswerObj.evaluationId);
    if (evaluationSectionAnswerObj.evaluation != null) evaluationSectionAnswer.setEvaluation(_.Evaluation.thaw(evaluationSectionAnswerObj.evaluation));
    if (evaluationSectionAnswerObj.sectionId != null) evaluationSectionAnswer.setSectionId(evaluationSectionAnswerObj.sectionId);
    if (evaluationSectionAnswerObj.skipped != null) evaluationSectionAnswer.setSkipped(evaluationSectionAnswerObj.skipped);
    if (evaluationSectionAnswerObj.section != null) evaluationSectionAnswer.setSection(_.EvaluationSection.thaw(evaluationSectionAnswerObj.section));
    if (evaluationSectionAnswerObj.questionAnswers != null) evaluationSectionAnswer.setQuestionAnswers(_.EvaluationQuestionAnswer.thawList(evaluationSectionAnswerObj.questionAnswers));
    return evaluationSectionAnswer;
  }

  static thawList(evaluationSectionAnswerObjList) {
    if (evaluationSectionAnswerObjList == null) return [];
    var evaluationSectionAnswers = [];

    for (var i = 0; i < evaluationSectionAnswerObjList.length; i++) {
      evaluationSectionAnswers.push(EvaluationSectionAnswer.thaw(evaluationSectionAnswerObjList[i]));
    }

    return evaluationSectionAnswers;
  }

  static freeze(evaluationSectionAnswer) {
    if (evaluationSectionAnswer == null) return null;
    var evaluationSectionAnswerObj = {};
    if (evaluationSectionAnswer.getId() != null) evaluationSectionAnswerObj.id = evaluationSectionAnswer.getId();
    if (evaluationSectionAnswer.getNotes() != null) evaluationSectionAnswerObj.notes = evaluationSectionAnswer.getNotes();
    if (evaluationSectionAnswer.getEvaluationId() != null) evaluationSectionAnswerObj.evaluationId = evaluationSectionAnswer.getEvaluationId();
    if (evaluationSectionAnswer.getEvaluation() != null) evaluationSectionAnswerObj.evaluation = _.Evaluation.freeze(evaluationSectionAnswer.getEvaluation());
    if (evaluationSectionAnswer.getSectionId() != null) evaluationSectionAnswerObj.sectionId = evaluationSectionAnswer.getSectionId();
    if (evaluationSectionAnswer.getSkipped() != null) evaluationSectionAnswerObj.skipped = evaluationSectionAnswer.getSkipped();
    if (evaluationSectionAnswer.getSection() != null) evaluationSectionAnswerObj.section = _.EvaluationSection.freeze(evaluationSectionAnswer.getSection());
    if (evaluationSectionAnswer.getQuestionAnswers() != null) evaluationSectionAnswerObj.questionAnswers = _.EvaluationQuestionAnswer.freezeList(evaluationSectionAnswer.getQuestionAnswers());
    return evaluationSectionAnswerObj;
  }

  static freezeList(evaluationSectionAnswers) {
    if (evaluationSectionAnswers == null) return [];
    var evaluationSectionAnswerObjList = [];

    for (var i = 0; i < evaluationSectionAnswers.length; i++) {
      evaluationSectionAnswerObjList.push(EvaluationSectionAnswer.freeze(evaluationSectionAnswers[i]));
    }

    return evaluationSectionAnswerObjList;
  }

  constructor() {
    this.setId(null);
    this.setNotes(null);
    this.setEvaluationId(null);
    this.setEvaluation(null);
    this.setSectionId(null);
    this.setSkipped(null);
    this.setSection(null);
    this.setQuestionAnswers(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setEvaluationId(evaluationId) {
    this.evaluationId = evaluationId;
  }

  setEvaluation(evaluation) {
    this.evaluation = evaluation;
  }

  setSectionId(sectionId) {
    this.sectionId = sectionId;
  }

  setSkipped(skipped) {
    this.skipped = skipped;
  }

  setSection(section) {
    this.section = section;
  }

  setQuestionAnswers(questionAnswers) {
    this.questionAnswers = questionAnswers;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getNotes() {
    return this.notes;
  }

  getEvaluationId() {
    return this.evaluationId;
  }

  getEvaluation() {
    return this.evaluation;
  }

  getSectionId() {
    return this.sectionId;
  }

  getSkipped() {
    return this.skipped;
  }

  getSection() {
    return this.section;
  }

  getQuestionAnswers() {
    return this.questionAnswers;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  wasStarted() {
    var _this$questionAnswers;

    let isSectionStarted = false;
    (_this$questionAnswers = this.questionAnswers) === null || _this$questionAnswers === void 0 ? void 0 : _this$questionAnswers.forEach(questionAnswer => {
      if ((questionAnswer === null || questionAnswer === void 0 ? void 0 : questionAnswer.getCheckboxValue()) != null) isSectionStarted = true;
    });
    if (this.notes != null && this.notes !== '') isSectionStarted = true;
    return isSectionStarted;
  } // Checks if all the questions were answered and all flagged risk factors addressed


  isComplete() {
    return this.areQuestionsComplete() && this.areRisksAddressed();
  } // Checks if there were any flagged risk factors for the given section


  wereRisksIdentified() {
    var _this$questionAnswers2;

    let risksIdentified = false;
    (_this$questionAnswers2 = this.questionAnswers) === null || _this$questionAnswers2 === void 0 ? void 0 : _this$questionAnswers2.forEach(questionAnswer => {
      if (!questionAnswer.isConditionalQuestion() && (questionAnswer === null || questionAnswer === void 0 ? void 0 : questionAnswer.getCheckboxValue()) === false) {
        risksIdentified = true;
      }
    });
    return risksIdentified;
  } // Checks if there were any flagged risk factors that haven't yet been addressed


  areRisksAddressed() {
    var _this$questionAnswers3;

    let risksAddressed = true;
    (_this$questionAnswers3 = this.questionAnswers) === null || _this$questionAnswers3 === void 0 ? void 0 : _this$questionAnswers3.forEach(questionAnswer => {
      if (!questionAnswer.isConditionalQuestion() && questionAnswer.getCheckboxValue() === false && !questionAnswer.getIsResolved()) risksAddressed = false;
    });
    return risksAddressed;
  } // Checks if all of the questions have been completed for the given section


  areQuestionsComplete() {
    var _this$questionAnswers4;

    let areEvaluationQuestionsComplete = true;
    (_this$questionAnswers4 = this.questionAnswers) === null || _this$questionAnswers4 === void 0 ? void 0 : _this$questionAnswers4.forEach(questionAnswer => {
      if ((questionAnswer === null || questionAnswer === void 0 ? void 0 : questionAnswer.getCheckboxValue()) == null && !(questionAnswer !== null && questionAnswer !== void 0 && questionAnswer.getIsNotApplicable())) areEvaluationQuestionsComplete = false;
    });
    return areEvaluationQuestionsComplete;
  }

}

exports.default = EvaluationSectionAnswer;